import React from 'react';
import {Body, Icon, designSystemToken} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import SOCIAL_NETWORK_ICON from '@/config/socialNetworkIconMap';
import {ContentCampaignIcon} from '@/components/unusual-icons/UnusualIcons';
import styles from './CampaignNetworkLabel.module.scss';

interface CampaignNetworkLabelProps {
  testID?: string;
  network: string;
}

// Maps the backend `network` value to a display name and icon.
// Looks up the icon name from SOCIAL_NETWORK_ICON (e.g. 'Social-Instagram'),
// then strips the 'Social-' prefix to get the brand-cased label ("Instagram",
// "TikTok", "YouTube"). Falls back to "Content" + the content icon for any
// network not in the map.
export default function CampaignNetworkLabel({
  testID = 'campaign-network-label',
  network,
}: CampaignNetworkLabelProps) {
  const iconName = SOCIAL_NETWORK_ICON[network?.toLowerCase?.()];
  const displayName = iconName
    ? iconName.replace(/^Social-/, '')
    : translate('Content');

  return (
    <div data-testid={testID} className={styles.networkRow}>
      {iconName ? (
        <Icon name={iconName} size="medium" appearance="neutral-secondary" />
      ) : (
        <ContentCampaignIcon
          width={20}
          height={20}
          color={designSystemToken('semantic.fg.tertiary')}
        />
      )}
      <Body size="lg" className={styles.networkLabel}>
        {displayName}
      </Body>
    </div>
  );
}
